import React from 'react';
import { Marker } from '@react-google-maps/api';
import { MarineWeatherMarkerData } from 'models/marineWeather';

interface MarineWeatherSwellMarkerProps {
  markerDataList: MarineWeatherMarkerData[];
  zoom: number;
  onHover: (windInfo: MarineWeatherMarkerData) => void;
  onUnhover: (windInfo: MarineWeatherMarkerData) => void;
}

export function MarineWeatherSwellMarker(props: MarineWeatherSwellMarkerProps): JSX.Element {
  const { markerDataList, zoom, onHover, onUnhover } = props;
  let scale = (zoom + 1) / 10;
  if (scale > 1) {
    scale = 1;
  }

  return (
    <React.Fragment>
      {markerDataList.map((markerData, i) => {
        return (
          <Marker
            key={'marker' + i}
            position={{ lat: markerData.latitude, lng: markerData.longitude }}
            icon={{
              fillColor: '#333333',
              fillOpacity: 0.6,
              strokeOpacity: 0.2,
              anchor: new window.google.maps.Point(12, 12),
              path: 'M12,2L4.5,20.29L5.21,21L12,18L18.79,21L19.5,20.29L12,2Z',
              rotation: markerData.swellDirection,
              scale: scale,
            }}
            onMouseOver={() => onHover(markerData)}
            onMouseOut={() => onUnhover(markerData)}
          />
        );
      })}
    </React.Fragment>
  );
}
